import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import moment from "moment";
import ManualJournalType from "./ManualJournalTypeSelect";
import { useNavigate, useSearchParams } from "react-router-dom";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { GetManualJournalAtom, GetManualJournalEditAtom, SetManualJournalEditAtom, SetManualJournalAtom } from "../../store/manualJounalAtom";
import { accountService } from "../../services/accountService";
import LogicContext from "../../Context/LogicContext";
import GeneralFileUploadPreview from "../../components/GeneralFileUploadPreview";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import ManualJTransactionTypeSelect from "./ManualJTransactionTypeSelect";
// Add account options array
let accountOptions = [
  { account_id: 1, account_name: "Example 1" },
  { account_id: 2, account_name: "Example 2" },
  { account_id: 3, account_name: "Example 3" },
  { account_id: 4, account_name: "Example 4" },

  // Add more account options as needed
];
// Add account options array
let taxOptions = [
  { tax_id: 1, tax_name: "Example 1" },
  { tax_id: 2, tax_name: "Example 2" },
  { tax_id: 3, tax_name: "Example 3" },
  { tax_id: 4, tax_name: "Example 4" },

  // Add more account options as needed
];


let credit = 0;
let debt = 0;
let debtDiff = 0;
let creditDiff = 0;


const NewManualJournalPage = () => {
  const journalAtom = GetManualJournalAtom();
  const setManualJournalAtom = SetManualJournalAtom();



  const journalEdit = GetManualJournalEditAtom();
  const setJournalEdit = SetManualJournalEditAtom();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [editable, setEditable] = useState({});
  const [clickedButtonOption, setClickedButton] = useState('');
  const isMounted = useRef(false);
  const [searchParams] = useSearchParams();

  // Get the specific parameter by name
  const journalNumber = searchParams.get('journal_number');

  const myPromiseModal = createModal(GeneralModal);
  const { register, setValue, getValues, handleSubmit, control, watch, reset, formState: { errors },
  } = useForm();

  const { fields, append, remove } = useFieldArray({ control, name: "journal_entries" });


  useEffect(() => {
    isMounted.current = true;

    if (journalAtom.chart_of_account) {
      accountOptions = journalAtom.chart_of_account;
    }

    if (journalAtom.tax_info) {
      taxOptions = journalAtom.tax_info;
    }

    return () => {
      isMounted.current = false;
    }

  }, [journalAtom?.chart_of_account]);

  useEffect(() => {
    if (!journalAtom.account_info?.length) {
      loadTableList();
    }

  }, []);

  useEffect(() => {
    isMounted.current = true;
    if (journalEdit?.length) {
      const tempEdit = journalEdit[0];
      setEditable(tempEdit);

      append(journalEdit);
      setValue('transaction_type_id', tempEdit.journal_type_id);
      setValue('journal_type_id', tempEdit.journal_type_id);
      setValue('reference_number', tempEdit.transaction_reference);
      setValue('attachment_url', tempEdit.attachement_url);
      setValue('notes', tempEdit.notes);
    } else {
      addRow();
    }

    return () => {
      setJournalEdit([]);
      isMounted.current = false;

    }

  }, [journalEdit?.reference_number]);

  const addRow = () => {
    append({ account_id: "", remark: "", debit_amount: 0, credit_amount: 0, tax_id: "" });
  };


  const removeRow = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
    credit = 0;
    debt = 0;
    debtDiff = 0;
    creditDiff = 0;
    calculateDebtCredit(fields)

  };

  const onTypeSelect = (sel) => {
    setValue('journal_type_id', sel.journal_type_id);
  }

  const onTransSelect = (sel) => {
    setValue('transaction_type_id', sel.code);
  }


  // Fetches the list of all manual journals from the server.
  const loadTableList = () => {
    accountService.manualJournal().then(res => {
      if (res.data && isMounted.current) {
        setManualJournalAtom(res.data);
      }
    });
  }


  function journalDateDateFunction() {
    let defaultDate = moment(Date.now()).format("YYYY-MM-DD");
    if (editable?.encoded_date !== undefined) {
      defaultDate = moment(editable?.encoded_date).format("YYYY-MM-DD");
    }

    return (
      <div className="">

        <input
          defaultValue={defaultDate}
          key={defaultDate}
          type="date"
          className="w-full border rounded px-3 py-2"
          {...register("journal_date", {
            required: "Journal date is required",
          })}
        />
        <br />
        <small className="text-red-500">
          {Boolean(errors["journal_date"]?.message) &&
            String(errors["journal_date"]?.message)}
        </small>
      </div>

    );
  }

  function onFileSelected(file) {
    setAttachmentFile(file);

  }

  const calculateDebtCredit = ((watchData) => {
    if (!watchData?.length)
      return;
    credit = 0;
    debt = 0
    watchData.forEach((table) => {
      credit += table.credit_amount || 0;
      debt += table.debit_amount || 0;

    });

    if (credit > debt) {
      creditDiff = credit - debt;
    }

    if (debt > credit) {
      debtDiff = debt - credit;
    }

  });


  const groupedAccountOptions = useMemo(() => {
    const groups = {};
    const source = journalAtom.chart_of_account || [];
    source.forEach(acc => {
      const key = acc.account_type_name || 'Other';
      if (!groups[key]) groups[key] = { label: key, accounts: [] };
      groups[key].accounts.push(acc);
    });
    return Object.values(groups);
  }, [journalAtom.chart_of_account]);

  const watchAllFields = watch();
  calculateDebtCredit(watchAllFields.journal_entries);





  const onSubmit = async (option) => {
    const formData = getValues();
    if (debt === 0 && credit === 0) {
      return logicContext.showToast("Credit or Debit must have a value", 'error');

    }
    let apiOption = clickedButtonOption;
    if (editable?.account_ref_no) {
      apiOption = 2;
    }

    // Construct the XML string from the journal entries.
    // This is a temporary solution and should be replaced with a more robust XML builder.
    let temp = ``;
    formData?.journal_entries.forEach(element => {
      temp += `<a><account_id>${element?.account_id}</account_id>
      <debit_amount>${element?.debit_amount || 0} </debit_amount>
      <credit_amount>${element?.credit_amount || 0} </credit_amount>
      <tax_id>${element?.tax_id} </tax_id>
      <remark>${element?.remark} </remark></a>`
    });

    let newFormData = {
      "journal_date": formData.journal_date,
      "reference_number": formData.reference_number,
      "journal_type_id": formData?.journal_type_id,
      "transaction_type_id": formData?.transaction_type_id,
      "notes": formData.notes,
      "currency_id": '',
      "xml_string": `<root>${temp} </root>`,
    }

    await myPromiseModal({
      title: editable?.account_ref_no ? "Update Journal" : "Create New Manual Journal?", body: editable?.account_ref_no ? `Manual journal will be updated` : `A new Manual Journal will be created!`,
      showInput: false, placeHolder: '',


    }).then((res) => {
      if (res.decision === true) {
        const formData = new FormData();

        for (const keyData in newFormData) {
          formData.set(keyData, newFormData[keyData] ? newFormData[keyData] : 0);
        }
        formData.set("option", apiOption);
        if (editable?.account_ref_no) {
          formData.set("account_ref_no", editable?.account_ref_no);
        }


        if (editable?.attachment_url) {
          formData.set("attachment_url", editable?.attachment_url);
        }

        if (attachmentFile) {
          formData.set('file', attachmentFile)
        }
        if (journalNumber) {
          formData.set('account_ref_no', journalNumber);
        }

        formData.delete('journal_entries'); // delete list
        accountService.createNewJournal(formData).then((res) => {
          const { message_text: Message_text, message_id } = res.data[0] || res.data?.result_status[0];
          if (message_id === 1) {
            logicContext.showToast(Message_text, "success");
            sessionStorage.setItem("reloadPage", "true");
            navigate(-1);

          } else {
            logicContext.showToast(Message_text, "error");
          }

          navigate(-1);
        }).catch((err) => {
          console.log('error ', err);
        })

      }

    });
  };



  return (
    <form onSubmit={handleSubmit(onSubmit)}>


      <div className="p-8 max-w-4xl mx-auto">
        <h1 className="text-xl font-bold mb-4">New Journal</h1>
        <div className="space-y-4">
          {/* Input Fields */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className=" font-semibold mb-1">Date*</label>
              {journalDateDateFunction()}
            </div>
            <div>
              <label className=" font-semibold mb-1">Journal#*</label>
              <input
                type="number"
                readOnly={true}
                placeholder="Auto generated"
                value={editable?.account_ref_no || journalNumber}
                className="w-full border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className=" font-semibold mb-1">Reference#</label>
              <input
                type="text"
                {...register("reference_number", {
                })}
                className="w-full border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className=" font-semibold mb-1">Notes*</label>
              <textarea
                className="w-full border rounded px-3 py-2"
                rows={2}
                maxLength={500}
                {...register("notes", {
                  // required: "Journal date is required",
                })}
              ></textarea>
            </div>
            <div>
              <label className=" font-semibold mb-1">Journal Type</label>
              <ManualJournalType list={journalAtom.journal_type} defaultVal={editable?.journal_type_name} onTypeSelect={onTypeSelect} />
            </div>
            <div>
              <label className=" font-semibold mb-1">Transaction Type</label>
              <ManualJTransactionTypeSelect disabled={editable?.transactionTypeId === 1} // Disable if transaction_type_id === 1
                defaultVal={editable?.transation_type_name} onTypeSelect={onTransSelect} />
            </div>
            <div>
              <label className=" font-semibold mb-1">Currency</label>
              <select className="w-full border rounded px-3 py-2">
                <option>NGN - Nigerian Naira</option>
                {/* Add more options if needed */}
              </select>
            </div>
          </div>

          {/* Table */}
          <div>

            <table className="w-full border border-gray-300 text-left">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-2 border">Account</th>
                  <th className="p-2 border">Description</th>
                  <th className="p-2 border">Tax</th>
                  <th className="p-2 border">Debits</th>
                  <th className="p-2 border">Credits</th>
                  <th className="p-2 border"></th>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, index) => (
                  <tr key={field.id}>
                    <td className="p-2 border">
                      <select
                        className="w-full border rounded px-2 py-1"
                        {...register(`journal_entries.${index}.account_id`)}
                      >
                        <option value="">Select </option>
                        {groupedAccountOptions.map(group => (
                          <optgroup key={group.label} label={group.label}>
                            {group.accounts.map(acc => (
                              <option key={acc.account_id} value={acc.account_id}>
                                {acc.account_name}
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </select>
                    </td>
                    <td className="p-2 border">
                      <input
                        type="text"
                        className="w-full border rounded px-2 py-1"
                        placeholder="Description"
                        {...register(`journal_entries.${index}.remark`)}
                      />
                    </td>

                    <td className="p-2 border">

                      <select
                        className="w-full border rounded px-2 py-1"
                        {...register(`journal_entries.${index}.tax_id`)}
                      >
                        <option value="">Select </option>
                        {taxOptions.map(tax => (
                          <option key={tax.tax_id} value={tax.tax_id}>
                            {tax.tax_name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="p-2 border">
                      <input
                        type="number"
                        step="0.01"
                        className="w-full border rounded px-2 py-1"
                        {...register(`journal_entries.${index}.debit_amount`, {
                          valueAsNumber: true
                        })}
                      />
                    </td>
                    <td className="p-2 border">
                      <input
                        type="number"
                        step="0.01"
                        className="w-full border rounded px-2 py-1"
                        {...register(`journal_entries.${index}.credit_amount`, {
                          valueAsNumber: true
                        })}
                      />
                    </td>
                    <td className="p-2 border text-center">
                      <button
                        type="button"
                        className="text-red-500"
                        onClick={() => removeRow(index)}
                      >
                        ✕
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button type="button"
              className="mt-4 text-blue-500"
              onClick={addRow}
            >
              + Add New Row
            </button>
          </div>

          <div className="relative w-full">
            <div className="absolute right-4 bg-white shadow-lg rounded-xl px-6 py-4 border border-gray-200 text-sm text-gray-700 space-x-6">
              <span className="font-semibold text-red-600 font-bold">Debit(s): {formatCustomNumber(debt)}</span>
              <span className="font-semibold text-green-600 font-bold">Credit(s): {formatCustomNumber(credit)}</span>
            </div>
          </div>



          {/* Sub Total */}
          <div className="mt-4 grid grid-cols-2 gap-6 items-center">
            <div>
              <div className="">
                <span className="text-sm ">Attach File</span>
                <GeneralFileUploadPreview
                  // defaultFileUrl={editableSalesOrder?.Sales_Order_Attachement_URL} 
                  onFileSelected={onFileSelected} />
                <i> maximum file size 2MB </i>
              </div>
            </div>
            {/* <div className="text-center">
            <p className="font-semibold">Sub Total: <span className="mr-2">{formatCustomNumber(debt)} </span> <span className="ml-2">{formatCustomNumber(credit) } </span></p>
            <p className="font-semibold">Total (NGN): <span className="mr-2">{formatCustomNumber(debt)} </span> <span className="ml-2">{formatCustomNumber(credit) } </span></p>
            <p className="font-semibold text-red-500">Difference: <span className="mr-2 text-red-500">{formatCustomNumber(debtDiff)} </span> <span className="ml-2 text-red-500">{formatCustomNumber(creditDiff) } </span> </p>
          </div> */}
          </div>
        </div>
        {/* buttons */}
        <div className="flex space-x-4 mt-6">
          <button onClick={() => setClickedButton('4')} className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-gray-800">
            {editable?.account_ref_no ? "Update" : "Save and Publish"}


          </button>
          <button onClick={() => setClickedButton('1')} className="bg-white text-gray-700 border border-gray-300 px-4 py-2 rounded hover:bg-gray-100">
            Save as Draft
          </button>
          <button type="button" onClick={() => navigate(-1)} className="bg-white text-gray-700 border border-gray-300 px-4 py-2 rounded hover:bg-gray-100">
            Cancel
          </button>
        </div>
        {/* buttons end */}
      </div>
    </form>
  );
};

export default NewManualJournalPage;
